/* eslint-disable no-unused-vars */

import { PolymerElement } from "@polymer/polymer/polymer-element.js";
import template from "./column-layout.html";

import { FlattenedNodesObserver } from "@polymer/polymer/lib/utils/flattened-nodes-observer.js";

/**
 * <p>The column-layout creates a grid and allows the user to specify how many columns 
 *    there should be.</p>
 *
 * <demo-snippet class="demoSnippet">
 *   <template>
 *     <style>
 *      iron-image {
 *        height: 190px;
 *        width: 100%;
 *      }
 *     </style>
 *     <h4>Auto-sizing columns</h4>
 *     <column-layout>
 *       <p>stuff 1</p>
 *       <p>stuff 2</p>
 *       <p>stuff 3</p>
 *       <p>stuff 4</p>
 *       <p>stuff 5</p>
 *       <p>stuff 6</p>
 *       <p>stuff 7</p>
 *       <p>stuff 8</p>
 *       <p>stuff 9</p>
 *       <p>stuff 10</p>
 *       <p>stuff 11</p>
 *     </column-layout>
 *     <br>
 *     <h4>Two column article style</h4>
 *     <column-layout columns="2">
 *       <section slot="col1">
 *         <p>Column 1. Lorem ipsum dolor sit amet consectetur adipisicing elit. Iusto iste 
 *            dolores explicabo temporibus asperiores illum culpa, odit ipsum eos 
 *            voluptas est accusantium et natus consectetur consequatur ullam modi 
 *            pariatur molestiae.</p>
 *         <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Eveniet 
 *            tempora exercitationem cum, iusto ipsa asperiores nisi doloribus 
 *            eligendi quibusdam, quasi ad praesentium in ea hic! Aliquid sunt 
 *            mollitia cumque animi.</p>
 *         <p>Lorem ipsum dolor sit, amet consectetur adipisicing elit. Illo 
 *            soluta, esse odit qui sed minima animi perspiciatis velit eaque 
 *            iusto necessitatibus explicabo minus vero sequi ea exercitationem 
 *            error provident tenetur.</p>
 *       </section>
 *       <section slot="col2">
 *         <p>Column 2. Lorem ipsum dolor sit amet consectetur adipisicing elit. Iusto iste 
 *            dolores explicabo temporibus asperiores illum culpa, odit ipsum eos 
 *            voluptas est accusantium et natus consectetur consequatur ullam modi 
 *            pariatur molestiae.</p>
 *         <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Eveniet 
 *            tempora exercitationem cum, iusto ipsa asperiores nisi doloribus 
 *            eligendi quibusdam, quasi ad praesentium in ea hic! Aliquid sunt 
 *            mollitia cumque animi.</p>
 *         <p>Lorem ipsum dolor sit, amet consectetur adipisicing elit. Illo 
 *            soluta, esse odit qui sed minima animi perspiciatis velit eaque 
 *            iusto necessitatibus explicabo minus vero sequi ea exercitationem 
 *            error provident tenetur.</p>
 *       </section>
 *     </column-layout>
 *     <h4>Images in a three column layout</h4>
 *     <column-layout columns="3">
          <iron-image slot="col1" preload sizing="cover"
              src="https://goo.gl/uPvN7F"></iron-image>
          <iron-image slot="col2" preload sizing="cover"
            src="https://goo.gl/ELDUtj"></iron-image>
          <iron-image slot="col3" preload sizing="cover"
            src="https://goo.gl/t8LmfZ"></iron-image>
 *     </column-layout>
 *   </template>
 * </demo-snippet>
 *
 */
export class ColumnLayout extends PolymerElement {
  constructor() {
    super();
  }

  static get is() {
    return "column-layout";
  }

  static get template() {
    let htmlElement = document.createElement("TEMPLATE");
    htmlElement.innerHTML = template;
    return htmlElement;
  }

  static get properties() {
    return {
      columns: {
        type: String,
        value: "2"
      }
    };
  }

  ready() {
    super.ready();
  }

  /**
   * When connected we need to observe the distributed children so we can calculate
   * any that have a class of 'fullbleed'
   * TODO: need to handle recalculating fullbleed when the screen is resized
   */
  connectedCallback() {
    super.connectedCallback();
    this._distNodesObserver = new FlattenedNodesObserver(
      this.$.default,
      (info) => {
        this._processNewNodes(
          info.addedNodes.filter((node) => {
            return node.nodeType === Node.ELEMENT_NODE;
          })
        );
        // this._processRemovedNodes(info.removedNodes);
      }
    );
  }

  /**
   * If the element is disconnected for some reason we need to also disconnect the observer
   */
  disconnectedCallback() {
    super.disconnectedCallback();
    this._distNodesObserver.disconnect();
  }

  /**
   * For each node in the flattened node tree look for those with a class of 'fullbleed'
   * and break them out of the grid.
   * @param {*} nodeList
   */
  _processNewNodes(nodeList) {
    this.distNodeList = nodeList;
    for (const key in nodeList) {
      if (nodeList.hasOwnProperty(key)) {
        const node = nodeList[key];
      }
    }
  }
}
customElements.define(ColumnLayout.is, ColumnLayout);
